import { useAppActions } from 'actions/app-actions';
import { useBrandActions } from 'actions/brand-actions';
import { useProfileActions } from 'actions/profile-actions';
import { useSessionActions } from 'actions/session-actions';

import { AppErrorStatusCode } from 'common/constants';
import { AppStateController } from 'common/controller/AppStateController';
import { SnackbarType } from 'common/interfaces';
import { IUserProfile } from 'common/interfaces/iprofile';
import UILogger, { LogRecordType, LogSeverityType } from 'common/utils/logger';
import { useEffect, useMemo, useState } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { checkUserSession } from 'services/auth-service';
import { retrieveSelectedBrandId } from 'services/db-service';
// import {startEventListener} from 'services/rng-client/event-handler';
import { RootState, store, useAppSelector } from 'setup/store';

const NonAuthAppInit = () => {
  // }, []);

  return (
    <>
      <Outlet />
      <AppErrorHandler />
    </>
  );
};

// const GlobalLoader = () => {
//   const { visible, message, disableBack } = useAppSelector((state) => state.appReducer.appLoaderState);
//   if (visible) return <Loader disableBack={disableBack} message={message} />;
//   return null;
// };

const AppErrorHandler = () => {
  const navigate = useNavigate();
  const { doPostLogoutCleanup, setAppConnected, setSnackBar } = useAppActions();
  const addAppErrorListener = (statusCode: AppErrorStatusCode) => {
    UILogger.error('appInit:addAppErrorListener::>>>>', statusCode);
    if (statusCode === AppErrorStatusCode.UNAUTHORIZED) {
      UILogger.error(
        'Unauthorized error detected. navigating to login screen. statusCode',
        statusCode,
        'loggedIn',
        store.getState().appReducer.isUserLoggedIn,
      );
      if (store.getState().appReducer.isUserLoggedIn) {
        doPostLogoutCleanup();
        navigate('/login');
      }
    } else if (statusCode == AppErrorStatusCode.ERR_NETWORK) {
      UILogger.error('Network error::>>>>');
      setAppConnected(false);
      setSnackBar(true, 'Could not connect to the server.', SnackbarType.ERROR);
    } else if (statusCode == AppErrorStatusCode.NONE) {
      UILogger.error('Network error gone::>>>>');
      setAppConnected(true);
    }
  };
  useEffect(() => {
    AppStateController.getInstance().subscribeAppError('appInit', addAppErrorListener);
  }, []);
  return null;
};

export default NonAuthAppInit;
